import { render, staticRenderFns } from "./edit-password.vue?vue&type=template&id=06693d32&scoped=true&"
import script from "./edit-password.ts?vue&type=script&lang=ts&"
export * from "./edit-password.ts?vue&type=script&lang=ts&"
import style0 from "./edit-password.scss?vue&type=style&index=0&id=06693d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06693d32",
  null
  
)

export default component.exports